import { ACHIEVEMENT_STATS } from '../../../constants/homeData';
import backgroundImage from '../../../assets/images/achievement.jpg';

function AchievementSection() {
  return (
    <section className="overflow-hidden">
      <div
        className="relative min-h-[280px] overflow-hidden bg-cover bg-no-repeat px-4 py-16 sm:px-6 sm:py-20 lg:min-h-[320px] lg:px-8 lg:py-24 xl:h-[394px] xl:pt-[114px] xl:pb-[114px] grayscale"
        style={{
          backgroundImage: `url(${backgroundImage})`,
        }}
      >
        <div className="absolute inset-0 bg-black/60 z-0"></div>
        <div className="relative z-10 mx-auto max-w-4xl text-center">
          <h2 className="text-4xl font-bold text-[#EBE7E7] sm:text-5xl lg:text-6xl xl:text-[64px]">
            Our Achievement
          </h2>

          <p className="mx-auto mt-4 max-w-2xl text-base font-semibold text-[#D9D9D9] sm:text-lg lg:text-[20px]">
            Discover Our Milestones &amp; Successes that makes CHSE Express Odisha&apos;s Top Online
            Learning Platform.
          </p>
        </div>
      </div>

      <div className="bg-[#CCCCCC] px-4 py-10 sm:px-6 sm:py-12 lg:px-8">
        <ul className="mx-auto grid max-w-6xl grid-cols-2 gap-10 sm:grid-cols-4 sm:gap-12">
          {ACHIEVEMENT_STATS.map((stat) => (
            <li key={stat.id} className="text-center">
              <p className="text-3xl font-bold text-[#1B1B1B] lg:text-[36px] xl:text-[40px]">{stat.value}</p>
              <p className="mt-2 text-base font-medium text-[#1B1B1B] lg:text-lg xl:text-[20px]">{stat.label}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default AchievementSection;
